module.exports = __webpack_public_path__ + "media/images/career_camp/2023/blurred_tree_1-f89679b55dbc1a8f3f5e66116046d7c9.png";